import React from 'react';
import * as S from './Styles';
import { NavigationItem } from './NavigationItem';
import { Package, ClockCounterClockwise, Storefront, Users}  from 'phosphor-react';

const navigationItems = [
    {
        title: 'Jobs',
        link: '/',
        icon: <Package size={23} />
    },
    {
        title: 'History',
        link: '/history',
        icon: <ClockCounterClockwise size={23} />
    },
    {
        title: 'Stores',
        link: '/stores',
        icon: <Storefront size={23} />
    },
]

const Navigation = () => (
    <S.NavigationItems>
        {navigationItems.map(navigationItem => (
            <NavigationItem key={navigationItem.title} {...navigationItem} />
        ))}
    </S.NavigationItems>
);

export { Navigation }
